export default function manager({ next, router }) {
    // console.log(router.app)
    if(router.app.$store && router.app.$store.state.logged && router.app.$store.state.user) {
        let role_id = parseInt(router.app.$store.state.user.primary_role_id)
        if([5].includes(role_id)) {
            return next()
        }
        router.push('/')
        return
    }
    router.push('/login')
}
